import { useEffect, useState } from 'react';

//components
import { Card } from 'primereact/card';

//api
import { ElaborationService } from '../../../service/elaboration-service';

        

const ElaborationCard = ()=>{
    const [elaborations, setElaborations]= useState(0)

    useEffect(()=>{
        const fetchElaborations = ()=>{
            ElaborationService.getAllElaborations(
                (data)=>{
                    setElaborations(data.count)
                },
                (error) => {
                    console.error("Errore durante il recupero delle elaborazioni: ", error);
                    
                }
            )
        }
        fetchElaborations()
    },[])

    return (
        <div>
            <Card title="Elaborazioni" className='dashboard__ElaborationWrapper'>
                <div className='dashboard__CardContent'>
                    <div>
                     {elaborations}
                    </div>
                    <div>
                       <i className='pi pi-list'></i> 
                    </div>
                </div>
                <div className='dashboard__Link'>
                    <a href='/dashboard/list_elaboration'>Vai alle elaborazioni <i className='pi pi-arrow-right' ></i></a>
                </div>
            </Card>
        </div>
    )
}

export default ElaborationCard